import { render, staticRenderFns } from "./TextEditorField.vue?vue&type=template&id=b380aaf2&"
import script from "./TextEditorField.vue?vue&type=script&lang=js&"
export * from "./TextEditorField.vue?vue&type=script&lang=js&"
import style0 from "./TextEditorField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
